export const columns = [
    {
        title:'参与日期',
        dataIndex:"payTime",
        key:"payTime"
    },
    {
        title:'姓名',
        dataIndex:"planterName",
        key:"planterName",
    },
    {
        title:'手机号',
        dataIndex:"phone",
        key:"phone"
    },
    {
      title:'支付金额',
      dataIndex:"plantingAmount",
      key:"plantingAmount"
  },
    {
      title:'植树状态',
      dataIndex:"plantingStatus",
      key:"plantingStatus",
      slots:"plantingStatus"
  },
    {
        title:'植树照片',
        dataIndex:"accessory",
        key:"accessory",
        slots:"accessory"
    },
    {
        title:'操作人',
        dataIndex:"revisorName",
        key:"revisorName"
    },
    {
        title:'操作时间',
        dataIndex:"updateTime",
        key:"updateTime"
    },
    {
        title: "操作",
        slots:'actions',
        width:180,
        fixed:'right'
    },
]